import React from "react";
import UnifiedGravityPlan from "../components/UnifiedGravityPlan";
import { useOrganization } from "../context/OrganizationContext";

const GravityPlans: React.FC = () => {
  const { selectedOrg } = useOrganization();

  if (!selectedOrg) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600">Please select an organization</p>
      </div>
    );
  }

  return <UnifiedGravityPlan />;
};

export default GravityPlans;
